import { WhilscoDigit } from "@/components/landing/WhilscoDigit";
import { PageFooterNav } from "@/components/landing/PageChrome";
import { SEO } from "@/components/SEO";

export default function PageWhilsco() {
  return (
    <>
      <SEO
        title="Whilsco-Digit SARL — Éditeur de Zafara"
        description="Whilsco-Digit SARL, studio produit basé à l'Île Maurice, édite Zafara — l'application marketplace 100% béninoise."
        path="/whilsco-digit"
      />
      <WhilscoDigit />
      <PageFooterNav
        prev={{ to: "/fondateur", label: "Le fondateur" }}
        next={{ to: "/contact", label: "Contact" }}
      />
    </>
  );
}
